var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "span",
    {
      class: `tag top`,
      staticStyle: {
        "--tag-background": "var(--fa-dk-navy)",
        "--tag-color": "white",
      },
    },
    [
      _vm.label.sr
        ? _c("span", { staticClass: "sr-only" }, [
            _vm._v("\n    " + _vm._s(_vm.label.sr) + "\n  "),
          ])
        : _vm._e(),
      _vm._v("\n  " + _vm._s(_vm.label.visible) + "\n"),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }